import { FC } from "react";
import classNames from "classnames";
import useTranslate from "hooks/useTranslate";
import { RANK_LEVEL_LOYALTY_IMAGES } from "constants/loyalty";
import { DESCRIPTIONS_CARD } from "./constants";
import { LoyaltyLevelRewardButtonProps } from "./types";
import "./styles.sass";

const LoyaltyLevelRewardButton: FC<LoyaltyLevelRewardButtonProps> = (props) => {
  const {
    nameRank,
    handleClick,
    variant,
    active,
    indexRank,
    startRequirementRank,
    endRequirementRank,
    userExperience,
  } = props;
  const image = RANK_LEVEL_LOYALTY_IMAGES[indexRank].rank;
  const { description, placeholder } = DESCRIPTIONS_CARD[variant];
  const t = useTranslate();

  const classNameRoot = classNames(
    "LoyaltyLevelRewardButton",
    `LoyaltyLevelRewardButton_${variant}`,
    active && "LoyaltyLevelRewardButton_active",
  );

  const classNameTop = classNames(
    "LoyaltyLevelRewardButton__top",
    `LoyaltyLevelRewardButton__top_${variant}`,
  );

  const classNamePlaceholder = classNames(
    "LoyaltyLevelRewardButton__placeholder",
    `LoyaltyLevelRewardButton__placeholder_${variant}`,
  );

  const calcPercentProgress =
    variant === "current"
      ? Math.floor(
          ((userExperience - startRequirementRank) /
            (endRequirementRank - startRequirementRank)) *
            100,
        )
      : 0;

  return (
    <button type="button" onClick={handleClick} className={classNameRoot}>
      <div className={classNameTop}>
        <div className="LoyaltyLevelRewardButton__infoRank">
          <span className="LoyaltyLevelRewardButton__title">{t(nameRank)}</span>
          <p className="LoyaltyLevelRewardButton__description">
            {t(description)}
          </p>
        </div>
        <img
          src={image}
          alt={`${nameRank}-image`}
          className="LoyaltyLevelRewardButton__img"
        />
      </div>
      <div className="LoyaltyLevelRewardButton__bottom">
        {variant === "current" ? (
          <div className="LoyaltyLevelRewardButton__progressbarContainer">
            <div className="LoyaltyLevelRewardButton__progressbarRequirements">
              <span className="LoyaltyLevelRewardButton__requirement">
                {t("loyalty.redesign.1.card.rank.placeholder.current")}{" "}
                {userExperience} XP
              </span>
              <span className="LoyaltyLevelRewardButton__requirement">
                {endRequirementRank} XP
              </span>
            </div>
            <div className="LoyaltyLevelRewardButton__progressbar">
              <div
                className="LoyaltyLevelRewardButton__progress"
                style={{ width: `${calcPercentProgress}%` }}
              />
            </div>
          </div>
        ) : (
          <span className={classNamePlaceholder}>{t(placeholder)}</span>
        )}
      </div>
    </button>
  );
};

export default LoyaltyLevelRewardButton;
